import { useSelector } from 'react-redux';
import { CampaignsState } from './campaigns.types';
import { getCampaigns } from './campaigns.state';

export const useCampaigns = () => {
    const campaigns : CampaignsState = useSelector(getCampaigns);

    return {
        campaigns,
    };
};
